import { render, staticRenderFns } from "./DetailBasicImageForm.vue?vue&type=template&id=545cadf8&scoped=true&"
import script from "./DetailBasicImageForm.vue?vue&type=script&lang=ts&"
export * from "./DetailBasicImageForm.vue?vue&type=script&lang=ts&"
import style0 from "./DetailBasicImageForm.vue?vue&type=style&index=0&id=545cadf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545cadf8",
  null
  
)

export default component.exports